import axios from 'axios';
//import get from "lodash/get";

const apiPostUrl = 'https://infoping.net/REST2/ask/Q/';
const API_DELETE = 'delete'; // Används för att ta bort konto
const API_INITIATE_LOGIN = 'json/?function=login_initiate'; // Används först vid login
const API_LOGIN_SMS_SEND = 'json/?function=login_sms_send'; // Begär att sms-koden ska skickas till numret
const API_CONFIRM_SMS_CODE = 'json/?function=login_sms_confirm'; // Skickar tillbaks session till backend;

//****** GENERAL FUNCTION POST TO BACKEND
export async function postToBackend(backendFunction, objectToSend) {
  let postData = JSON.stringify(objectToSend);
  const fullQueryUrl = apiPostUrl + backendFunction;
  // console.log('Post to backend:', fullQueryUrl, 'with postData:', postData);
  return await axios
    .post(fullQueryUrl, postData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((responseFromBackend) => {
      //  console.log(
      //    'Response from postToBackend on function:',
      //    backendFunction,
      //   responseFromBackend
      //  );
      return responseFromBackend.data;
    })
    .catch((e) => {
      return { status: 0, error: e.message };
    });
}

export {
  API_DELETE,
  API_INITIATE_LOGIN,
  API_LOGIN_SMS_SEND,
  API_CONFIRM_SMS_CODE,
};
